export default __webpack_public_path__ + "static/media/callraise_0008_thumb.8aefb807.jpg";